import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RobitoLogo from "../components/RobitoLogo";
import { apiPostPublic, apiPostAuth} from "../utils/api";
import "../App.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await apiPostAuth("account/is_logged_in.php");
        if (response.status === 'success') {
          window.location.href = "/dashboard";
        } 
      } catch (error) {
        
      }
    };

    checkLogin();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Make API call to register.php
      const response = await apiPostPublic("login.php", {
        email: email,
        password: password,
      });


      if (response.result === 1) {
        // Redirect user to dashboard page
        window.location.href = "/dashboard";
      } else {
        alert(response.message || "Login failed. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while registering.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Login to your account</h2>
        <form onSubmit={handleLogin} className="form-container">
          <input
            type="email"
            placeholder="Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          <div className="forgot-password">
            <Link to="/forgot-password" className="link">Forgot Password?</Link>
          </div>

          <button type="submit" className="primary-button">Login</button>
        </form>

        <p className="form-footer">
          Don’t have an account? <Link to="/register" className="link">Create Account</Link>
        </p>
        <div className="copyright">© Robito.Ai 2025</div>
      </div>
    </div>
  );
};

export default LoginPage;
